export default __webpack_public_path__ + "static/media/MY.05adc6be.svg";